import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from '../Components/NavBar/NavBar';
import Footer from '../Components/Footer/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <NavBar />  
      <Outlet />  
      <Footer />
    </div>
  );
}

export default App;
